import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'src/common/refactoredComponents/select/Select';
import { sizes } from 'src/styles/Media.styled';
import { ProductErrorText, AlertIcon } from '../NonTissueProductCard.styled';
import { useSelector } from 'react-redux';
import { US_COUNTRY_CODE } from 'src/constants/appConstants';

const DropdownWithErrorText = ({
    AlertCircleOutline,
    nonTissueProduct,
    batchLocations,
    selectedBatchLocationTemplate,
    batchLocationTemplate,
    selectedLocation,
    handleLocationChange,
    checked,
    allocatedData,
}) => {
    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const { t } = useTranslation();
    return (
        <>
            {checked ? (
                <>
                    <Select
                        id={'surgery-shipping-productCard-batchSelection'}
                        placeholder={t(
                            'scheduleSurgery.Shipping.ProductCard.BatchSelectionDefault'
                        )}
                        options={
                            batchLocations?.batchAllocations
                                ?.filter((batch) => countryISOCode!==US_COUNTRY_CODE ? true : batch.isParked).sort((a, b) => {
                                    return a.id - b.id;
                                })
                                .map((batch) => {
                                    return {
                                        ...batch,
                                        currentLocationFormatted: `${t(
                                            'scheduleSurgery.Shipping.BatchLocationCard.batchLabel'
                                        )} ${batch.id}: ${
                                            batch.isBatchAlreadyAllocated
                                                ? batch.batchAlreadyAllocated[0]
                                                      ?.accountName
                                                : batch.currentLocation
                                        } `,
                                    };
                                }) || []
                        }
                        optionLabel="currentLocation"
                        valueTemplate={selectedBatchLocationTemplate}
                        optionValue="id"
                        itemTemplate={batchLocationTemplate}
                        value={selectedLocation}
                        onChange={handleLocationChange}
                        emptyMessage={t(
                            'scheduleSurgery.Shipping.ProductCard.NoBatchAvailable'
                        )}
                        labelColor="#202124"
                        borderRadius="6px"
                        selectedLabelFontSize="14px"
                        showClear={selectedLocation ? true : false}
                        //onChange={ addBatchLocationToProduct}

                        scrollHeight={
                            window.innerWidth <= sizes.mobileDevice
                                ? '135px'
                                : '200px'
                        }
                    />
                    {nonTissueProduct.batchAllocationError && (
                        <ProductErrorText>
                            <AlertIcon
                                src={AlertCircleOutline}
                                height="14px"
                                width="auto"
                            />
                            <div>
                                {t(
                                    'scheduleSurgery.Shipping.ProductCard.batchAllocationError'
                                )}
                            </div>
                        </ProductErrorText>
                    )}
                </>
            ) : (
                <></>
            )}
            {checked ? allocatedData : null}
        </>
    );
};

export default DropdownWithErrorText;
